var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntellij = function SvgIntellij(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "intellij_svg__a",
    x1: -0.717,
    x2: 24.145,
    y1: 7.619,
    y2: 61.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FC801D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FE2857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "intellij_svg__b",
    x1: 4.222,
    x2: 62.927,
    y1: 60.019,
    y2: 1.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FE2857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#007EFF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8100",
    d: "m15.948 5.816-11.876.002A4.07 4.07 0 0 0 0 9.891v11.507c0 1.188.52 2.318 1.422 3.092l38.16 32.71c.74.632 1.68.98 2.652.98h11.875a4.073 4.073 0 0 0 4.073-4.073V42.6c0-1.189-.52-2.319-1.422-3.092L18.599 6.797a4.07 4.07 0 0 0-2.651-.98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#intellij_svg__a)",
    d: "M14.52 5.816H4.072A4.073 4.073 0 0 0 0 9.89v13.093q0 .289.04.576l5.278 36.944a4.07 4.07 0 0 0 4.032 3.496h15.673a4.073 4.073 0 0 0 4.073-4.074l-.005-18.538c0-.438-.07-.872-.209-1.287L18.382 8.6a4.07 4.07 0 0 0-3.863-2.785"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#intellij_svg__b)",
    d: "M59.928 0H25.959c-1.629 0-3.101.971-3.743 2.468L6.148 39.958a4.1 4.1 0 0 0-.33 1.605v18.364A4.073 4.073 0 0 0 9.891 64h17.966c.805 0 1.591-.238 2.261-.685L62.187 41.91a4.07 4.07 0 0 0 1.811-3.387L64 4.073A4.073 4.073 0 0 0 59.928 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52 12H12v40h40z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 29.386h2.979v-9.772H17V17h8.839v2.614H22.86v9.772h2.979V32H17zM27.339 29.3h2.154q.653 0 1.162-.278.51-.279.787-.787a2.4 2.4 0 0 0 .279-1.163V17h2.925v10.275q0 1.35-.622 2.427a4.44 4.44 0 0 1-1.714 1.687Q31.217 32 29.856 32H27.34zM17 44h16v3H17z"
  })));
};
export default SvgIntellij;